import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import './InterviewerRatings.css';

const InterviewerRatings = ({ interviewerId }) => {
  const [ratings, setRatings] = useState([]);
  const [averageRating, setAverageRating] = useState({ averageRating: 0, count: 0 });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchRatings = async () => {
      try {
        setLoading(true);
        
        // Fetch average rating
        const averageRes = await api.get(`/api/ratings/interviewer/${interviewerId}/average`);
        setAverageRating(averageRes.data);
        
        // Fetch detailed ratings
        const ratingsRes = await api.get(`/api/ratings/interviewer/${interviewerId}`);
        setRatings(ratingsRes.data);
        
        setLoading(false);
      } catch (err) {
        console.error('Error fetching ratings:', err);
        setError('Failed to load ratings. Please try again later.');
        setLoading(false);
      }
    };

    if (interviewerId) {
      fetchRatings();
    }
  }, [interviewerId]);

  const renderStars = (rating) => {
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      if (i <= rating) {
        // Full star
        stars.push(<i key={i} className="fas fa-star"></i>);
      } else if (i - 0.5 <= rating) {
        // Half star
        stars.push(<i key={i} className="fas fa-star-half-alt"></i>);
      } else {
        // Empty star
        stars.push(<i key={i} className="far fa-star"></i>);
      }
    }
    return stars;
  };

  if (loading) {
    return <div className="ratings-loading">Loading ratings...</div>;
  }

  if (error) {
    return <div className="ratings-error">{error}</div>;
  }

  return (
    <div className="interviewer-ratings-container">
      <div className="ratings-summary">
        <h3>Your Rating</h3>
        <div className="average-rating">
          <div className="rating-stars">{renderStars(averageRating.averageRating)}</div>
          <div className="rating-number">{averageRating.averageRating.toFixed(1)}</div>
          <div className="rating-count">({averageRating.count} {averageRating.count === 1 ? 'rating' : 'ratings'})</div>
        </div>
      </div>

      {ratings.length > 0 ? (
        <div className="ratings-list">
          <h3>Individual Ratings</h3>
          {ratings.map((rating) => (
            <div key={rating._id} className="rating-item">
              <div className="rating-header">
                <div className="rating-stars">{renderStars(rating.rating)}</div>
                <div className="rating-date">
                  {new Date(rating.createdAt).toLocaleDateString()}
                </div>
              </div>
              {rating.feedback && (
                <div className="rating-feedback">
                  <p>{rating.feedback}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      ) : (
        <div className="no-ratings">
          <p>You haven't received any ratings yet.</p>
        </div>
      )}
    </div>
  );
};

export default InterviewerRatings;
